import { Button, Stack, Typography } from '@mui/material';
import { useApolloClient } from '@apollo/client';
import { useEffect } from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { styled } from '@mui/material/styles';
import { ME_QUERY } from '~/graphql/queries/me';

/**
 * Stripe Account Link `return_url`. Completion is confirmed via webhook; refetch profile for best-effort UI.
 */
const ExpertStripeOnboardingReturnPage = () => {
  const apolloClient = useApolloClient();

  useEffect(() => {
    void apolloClient.refetchQueries({
      include: 'active',
    });
    void apolloClient.query({ query: ME_QUERY, fetchPolicy: 'network-only' });
  }, [apolloClient]);

  return (
    <Root spacing={2}>
      <PageTitle variant="h6">Payout setup</PageTitle>
      <Body variant="body2" color="text.secondary">
        Thanks for completing the Stripe steps. Your account may take a moment
        to verify—we will update your profile when payouts are ready.
      </Body>
      <Button
        component={RouterLink}
        to="/matters"
        variant="contained"
        fullWidth
      >
        Back to matters
      </Button>
    </Root>
  );
};

const Root = styled(Stack)(({ theme }) => ({
  maxWidth: 480,
  marginLeft: 'auto',
  marginRight: 'auto',
  paddingTop: theme.spacing(2),
  paddingBottom: theme.spacing(2),
}));

const PageTitle = styled(Typography)(({ theme }) => ({
  fontWeight: 700,
  marginBottom: theme.spacing(0.5),
}));

const Body = styled(Typography)(({ theme }) => ({
  marginBottom: theme.spacing(1),
}));

export default ExpertStripeOnboardingReturnPage;
